export const palette = {
  white: "#ffffff",
  black: "#222222",
  action: {
    primary: "#7C60D9",
    darker: "#46367A",
    lighter: "#BCAFE6",
    lightest: "#F2EFFC",
    reverse: "#ffffff"
  },
  gray: {
    primary: "#596266",
    lighter: "#A6AEB2",
    lightest: "#E6E9EB",
    hover: "#F5F5F5",
    fill: "#FAFAFA"
  },
  purple: {
    primary: "#7C60D9",
    darker: "#46367A",
    lighter: "#BCAFE6",
    lightest: "#F2EFFC"
  },
  red: {
    primary: "#E45C52",
    darker: "#8F150B",
    lighter: "#EDB8B4",
    lightest: "#FAF1F0"
  },
  green: {
    primary: "#6DCC6A",
    lighter: "#A9DDA8",
    lightest: "#EBF5EB"
  },
  orange: {
    primary: "#FF8C00",
    lighter: "#F9BF78",
    lightest: "#FDF4E9"
  },
  yellow: {
    primary: "#FFBF00",
    lighter: "#FFEAAD",
    lightest: "#FFFAEB"
  },
  teal: {
    primary: "#39A4A1",
    darker: "#2B7A78",
    lighter: "#A7DBDA",
    lightest: "#DFEBEA"
  },
  blue: {
    lighter: "#BCDBE6",
    lightest: "#EBFAFF"
  }
};